const OrganizationList = () => {
    return (
        <>

        </>
    );
};

export default OrganizationList;
